import { FC, useEffect, useState } from 'react';
import Input from 'components/new-ui/base/input/Input';
import useDebouncedValue from 'hooks/useDebouncedValue';

const APPLY_DEBOUNCE_MS = 500;

interface Props {
    placeholder: string;
    value?: string;
    maxLength?: number;
    onApply: (value: string) => void;
}

// The input updates on every keystroke; the filter is applied once the user pauses typing
const FilterInput: FC<Props> = ({ placeholder, value = '', maxLength, onApply }) => {
    const [draft, setDraft] = useState(value);
    const debouncedDraft = useDebouncedValue(draft, APPLY_DEBOUNCE_MS);

    useEffect(() => {
        const trimmed = debouncedDraft.trim();
        if (trimmed !== value) onApply(trimmed);
        // Only a change of the typed text should apply the filter
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedDraft]);

    return (
        <Input
            allowClear
            style={{ width: 200 }}
            placeholder={placeholder}
            maxLength={maxLength}
            value={draft}
            onChange={(event) => setDraft(event.target.value)}
        />
    );
};

export default FilterInput;
